import { combineReducers } from '@reduxjs/toolkit'

import { REDUCER_INDEX } from '../constants'
import * as list from './list'
import * as team from './team'

export * as list from './list'
export * as team from './team'

export const actions = {
  ...team.actions,
  ...list.actions,
}

export const epics = [...team.epics, ...list.epics]

export const reducer = combineReducers({
  list: list.reducer,
  team: combineReducers({
    team: team.reducer,
  }),
})

export const selectors = {
  list: ({ [REDUCER_INDEX]: state }: { [REDUCER_INDEX]: ReturnType<typeof reducer> }) => state.list,
  team: ({ [REDUCER_INDEX]: state }: { [REDUCER_INDEX]: ReturnType<typeof reducer> }) => state.team.team,
}
